import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStorage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStorage"><Path d="M4.5 19V16.5H19.5L19.5 19M19.5 19L19.5 2.5H4.5V21.5H19.5L19.5 19ZM14 18.75H14.5V19.25H14V18.75ZM16.75 18.75H17.25V19.25H16.75V18.75Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStorage;
